import { observer } from "mobx-react-lite";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { InstructionsField } from "./InstructionsField";
import { useGroupUpdate } from "./useGroupUpdate";

interface BodyInstructionsFieldProps {
  workoutItemId: string;
}

export const BodyInstructionsField = observer(function BodyInstructionsField(
  props: BodyInstructionsFieldProps,
) {
  const workoutEditStore = useWorkoutEditStore();
  const workoutItem = workoutEditStore.getGroupWorkoutItemById(
    props.workoutItemId,
  );
  const { handleUpdate } = useGroupUpdate(props.workoutItemId);

  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <div onClick={handleStopPropagation}>
      <InstructionsField
        value={workoutItem.instructions}
        onChange={(value) => {
          handleUpdate({ instructions: value });
        }}
      />
    </div>
  );
});
